import React from "react";
import weathersnooper from './images/weathersnooper.jpg';
import pizzaprophet from './images/thepizzaprophet.jpg';
import bus from './images/BusTrack.jpg';
import lotto from './images/lotto.jpg';
import attractions from './images/attractions.jpg';
import bank from './images/BadBank.jpg';
import randl from './images/randl.jpg';
import frank from './images/frankentool.jpg';
import mern from './images/mern.png';
import Footer from './footer';
import html from './images/html.png';
import js from './images/js.png';
import css from './images/css.png';
import react from './images/react1.png';
import fox from './images/fox.png';
import honey from './images/honey.png';
import taxidermy from './images/taxidermy.png';
import oak from './images/oak.png';
import development from './images/Development.png';
import design from './images/design.png';
import snake from './images/snake.png';


function toggleDiv(event) {
      if (event.target.id === "dev") {
            document.getElementById("devPort").style.display = "block";
            document.getElementById("desPort").style.display = "none";
      } else if (event.target.id === "design") {
            document.getElementById("devPort").style.display = "none";
            document.getElementById("desPort").style.display = "block";   
      }
}

export default function Portfolio(){
    return (
        <>
            <div id="portSelect" style={{textAlign: "center"}}>
                  <img id="dev"  onClick={toggleDiv} src={development} alt="development"/>
                  <img id="design" onClick={toggleDiv} src={design} alt="ddesign"/>
            </div>
                  <div id="devPort" style={{textAlign: "center", marginBottom: "15px"}}>	
                        <span className="card">
                              <div className="card-header"><span>Weather Snooper</span></div>
                              <div className="card-body"><a href="https://weathersnooper.com" target="_blank" rel="noreferrer"><img src={weathersnooper} style={{width: "100%"}} alt=""/></a></div> 
                              <div className="card-footer"><img src={html} width="50px" alt="" /><img src={js} style={{borderRadius: "10px"}} width="40px" alt="" /><img src={css} width="50px" alt="" /></div>
                        </span>
                        <span className="card">
                              <div className="card-header"><span>R &amp; L Repair</span></div>
                              <div className="card-body"><a href="http://randlrepair.com" target="_blank" rel="noreferrer"><img src={randl} style={{width: "100%"}} alt=""/></a></div> 
                              <div className="card-footer"><img src={react}  width="50px" alt="" /><img src={css} width="50px" alt="" /></div>
                        </span>
                        <span className="card">
                              <div className="card-header"><span>Attractions Salon (in development)</span></div>
                              <div className="card-body"><a href="http://www.beta.13media13.com/" target="_blank" rel="noreferrer"><img src={attractions} style={{width: "100%"}} alt=""/></a></div> 
                              <div className="card-footer"><img src={react} width="50px" alt="" /><img src={css} width="50px" alt="" /></div>
                        </span>
                        <span className="card">
                              <div className="card-header"><span>Lotto Generator</span></div>
                              <div className="card-body"><a href="http://www.lotto.13media13.com/" target="_blank" rel="noreferrer"><img src={lotto} style={{width: "100%"}} alt=""/></a></div> 
                              <div className="card-footer"><img src={html} width="50px" alt="" /><img src={js} style={{borderRadius: "10px"}} width="40px" alt="" /><img src={css} width="50px" alt="" /></div>
                        </span>
                        <span className="card">
                              <div className="card-header"><span>The Pizza Prophet (in development)</span></div>
                              <div className="card-body"><a href="https://snoopthepizzaprophet.com/" target="_blank" rel="noreferrer"><img src={pizzaprophet} style={{width: "100%"}} alt=""/></a></div> 
                              <div className="card-footer"><img src={html} width="50px" alt="" /><img src={js} style={{borderRadius: "10px"}} width="40px" alt="" /></div>            
                        </span>
                        <span className="card">
                              <div className="card-header"><span>MBTA Bus Tracker</span></div>
                              <div className="card-body"><a href="https://rbouchard13.github.io/mbta_realtime_tracker" target="_blank" rel="noreferrer"><img src={bus} style={{width: "100%"}} alt=""/></a></div> 
                              <div className="card-footer"><img src={js} style={{borderRadius: "10px", marginBottom: "10px"}} width="40px" alt="" /></div>
                        </span>
                        <span className="card">
                              <div className="card-header"><span>MERN Full Stack Bank Sample</span></div>
                              <div className="card-body"><a href="https://badbank.13media13.com/" target="_blank" rel="noreferrer"><img src={bank} style={{width: "100%"}} alt=""/></a></div> 
                              <div className="card-footer"><img src={mern} width="125px" alt=""/></div>
                        </span>
                        <span className="card">
                              <div className="card-header"><span>HTA Frankentool</span></div>
                              <div className="card-body"><img src={frank} style={{width: "95%"}} alt=""/></div> 
                              <div className="card-footer"><img src={html} width="50px" alt="" /></div>
                        </span>
                  </div>
                  <div id="desPort" style={{textAlign: "center", marginBottom: "15px"}}>
                        <img src={oak} width="425px" alt="Oak Acres" />
                        <img src={taxidermy} width="425px" alt="Taxidermy" />
                        <img src={fox} width="425px" alt="Fox" />
                        <img src={honey} width="425px" alt="Honey" />
                        <img src={snake} width="425px" alt="snake" />
                  </div> 
        <Footer />
        </>
    )
}